import { render, staticRenderFns } from "./videoScoring.vue?vue&type=template&id=a83f65ea&scoped=true"
import script from "./videoScoring.vue?vue&type=script&lang=js"
export * from "./videoScoring.vue?vue&type=script&lang=js"
import style0 from "./videoScoring.vue?vue&type=style&index=0&id=a83f65ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83f65ea",
  null
  
)

export default component.exports